import { API_BASE_URL_ENV } from "../../jsx/common/common";
import BaseService from "../BaseService";
import http from "../HttpService";

const apiEndpoint = API_BASE_URL_ENV() + "/roles";
const apiGetModuleEndpoint = API_BASE_URL_ENV() + "/roles/permissions";

export default class RolesService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
	getModule = () => {
		return http.get(apiGetModuleEndpoint);
	};
}
